import React from 'react';

import type { SubscriberComment } from '@utils/backend-api/subscriber_directory';
import { stripHtml } from '@utils/formatting';

interface PersonalActivityCardProps {
  item: SubscriberComment;
  onClick: (text: string, id?: number) => void;
}

const PersonalActivityCard = ({ item, onClick }: PersonalActivityCardProps) => {
  const displayText = item.type === 'forum_post' ? item.commentableTitle : item.body;

  return (
    <article className="flex flex-col justify-between gap-24 border-0 border-r border-solid border-grayscale-gray pr-24 last-of-type:border-r-0 last-of-type:pr-0">
      <div className="mt-16 flex flex-col gap-8">
        {item.type === 'comment' && (
          <span className="text-grayscale-dark-gray font-suisse-neue text-body-sm">
            Your comment on:{' '}
            <a
              className="font-bold transition-colors duration-150 hover:text-primary-magenta"
              href={item.commentableUrl}
              onClickCapture={() => onClick(item.commentableTitle)}
            >
              {item.commentableTitle}
            </a>
          </span>
        )}
        <a
          className="line-clamp-3 block font-suisse-neue text-body-md font-normal text-black no-underline transition-colors duration-150 hover:text-primary-magenta"
          href={item.commentableUrl}
          onClickCapture={() => onClick(item.commentableTitle)}
        >
          {stripHtml(displayText)}
        </a>
      </div>
      <span className="text-grayscale-dark-gray font-suisse-neue text-body-sm">
        {item.commentCreated}
      </span>
    </article>
  );
};

export default PersonalActivityCard;
